import { BasicControl, CURSOR_TYPE, DYMODE_MODE, LineT, Listeners, ModelBase, ModelUtils, TnEngineContext, TnEngineExtraContext, ViewEditor } from "pytha";
import { Vector3 } from "three";
import { PYTHA_CTRL_TYPE } from "../enums/control-type";
import { StationGroupCommand } from "../commands/StationGroupCommand";



const MOUSE = {
    LEFT: 0,
    MIDDLE: 1,
    RIGHT: 2,
}

const STEP = {
    0: { 'tip': '选择对象', 'mode': DYMODE_MODE.TIPONLY },
    // 1: { 'tip': '指定基点', 'mode': DYMODE_MODE.POINT },
    // 2: { 'tip': '指定第二个点', 'mode': DYMODE_MODE.POINT },
}

export class StationGroupControl extends BasicControl {

    id: number = PYTHA_CTRL_TYPE.PYTHA_ERASE;

    // 基点和第二个点
    // point_first: Vector3 = new Vector3();
    // point_second: Vector3 = new Vector3();

    step: number = 0;

    selectedEntities: ModelBase[] = [];
    selectedEntitiesClone: ModelBase[] = [];

    capturePoint: Vector3;

    dymodePoint: Vector3 = new Vector3();

    orthogonalPoint: Vector3;

    polarPoint: Vector3;

    line: LineT = new LineT();

    timer$;

    context: TnEngineContext;
    extraContext: TnEngineExtraContext;

    constructor(editor: ViewEditor, listeners: Listeners) {
        super();
        // 使用构造函数，在创建类的对象时，直接给成员变量赋值
        this.context = TnEngineContext.getInstance();
        this.extraContext = TnEngineExtraContext.getInstance();
        this.editor = editor;
        this.listeners = listeners;
        this.line._isHelpLine = true;
        // 注册监听指针事件
        editor.renderer.domElement.addEventListener('pointerdown', this.onPointerDown);
        editor.renderer.domElement.addEventListener('pointermove', this.onPointerMove);
        // 订阅确认信号
        this.listeners.signals.onKeyMouseConfirm.add(this.onKeyMouseConfirm);
        // 订阅点捕捉信号，收听到捕捉点的坐标
        this.listeners.signals.onPointCapture.add(this.onPointCapture);
        // 订阅正交信号，收听到正交模式点的坐标
        this.listeners.signals.onPointOrthogonal.add(this.onPointOrthogonal);
        // 订阅极轴追踪信号，收听到极轴追踪点的坐标
        this.listeners.signals.onPointPolarTracking.add(this.onPointPolarTracking);
        // 订阅组创建或修改信号
        this.listeners.signals.onGroupChanged.add(this.onGroupChanged);
        // 激活选择
        this.editor.selectControl.setEnabled(true);
        // 激活动态输入
        this.extraContext.dymodeContext.enabled = true;
        this.editor.clampControl.enabled = false;
        this.editor.clampControl.hidden = true;
        this.timer$ = setTimeout(this.init, 0);
        console.log('GroupControl add')
    }

    dispose(): void {

        this.editor.renderer.domElement.removeEventListener('pointerdown', this.onPointerDown);
        this.editor.renderer.domElement.removeEventListener('pointermove', this.onPointerMove);
        this.listeners.signals.onKeyMouseConfirm.remove(this.onKeyMouseConfirm);
        this.listeners.signals.onPointCapture.remove(this.onPointCapture);
        this.listeners.signals.onPointOrthogonal.remove(this.onPointOrthogonal);
        this.listeners.signals.onPointPolarTracking.remove(this.onPointPolarTracking);
        this.listeners.signals.noNeedCapture.dispatch();
        // 派发置空选择集的信号
        this.listeners.signals.emptySelectedEntities.dispatch();
        this.listeners.signals.onGroupChanged.remove(this.onGroupChanged);
        this.editor.selectControl.setEnabled(true);
        this.extraContext.dymodeContext.enabled = false;
        this.editor.clampControl.enabled = true;
        this.editor.clampControl.hidden = false;
        this.editor.orthogonalControl.enabled = false;
        this.editor.polarControl.enabled = false;
        console.log('GroupControl removed')
    }

    init = () => {
        this.selectedEntities = this.editor.selectControl.getSelectedEntityList().filter(entity => !entity.lock);
        if (this.selectedEntities.length === 0) {
            // 派发动态输入信息
            this.listeners.signals.sendToDymodeTip.dispatch(STEP[this.step].tip + ':');
            this.extraContext.dymodeContext.setMode(STEP[this.step].mode);
            this.extraContext.stmodeContext.setStmode(STEP[this.step].tip);
            this.listeners.signals.onCursorChange.dispatch(CURSOR_TYPE.PICK);
        } else {
            this.onKeyMouseConfirm();
        }
    }

    onPointPolarTracking = (point) => {
        this.polarPoint = point;
    }

    onPointCapture = (point) => {
        this.capturePoint = point;
    }

    onPointOrthogonal = (point) => {
        this.orthogonalPoint = point;
    }

    onPointerDown = (event) => {
        if (event.button !== MOUSE.LEFT) return;
    }

    onPointerMove = (event) => {
        this.dymodePoint.set(this.extraContext.mousePosContext.x, this.extraContext.mousePosContext.y, this.extraContext.mousePosContext.z);
    }

    onGroupChanged = () => {

    }

    lastStep = () => {
        let entities = this.selectedEntities;
        this.editor.history.execute(new StationGroupCommand(entities, ModelUtils.generateUUID(), true));
        this.listeners.signals.onOpeCommandControlEnd.dispatch();
        this.dispose();
    }

    onKeyMouseConfirm = () => {
        this.selectedEntities = this.editor.selectControl.getSelectedEntityList().filter(entity => !entity.lock);
        if (!this.selectedEntities.length) {
            this.listeners.signals.onOpeCommandControlEnd.dispatch();
        } else {
            this.lastStep();
        }
    }
}